import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import BrandIntro from './components/BrandIntro';
import CategoryGrid from './components/CategoryGrid';
import FeatureCards from './components/FeatureCards';
import ArticleResources from './components/ArticleResources';
import Testimonial from './components/Testimonial';
import CTASection from './components/CTASection';

const siteUrl = import.meta.env.VITE_SITE_URL;

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'ACBuySpreadsheet',
  url: `${siteUrl}/`,
  description: 'The ultimate ACBuy spreadsheet system for tracking orders, calculating profit, and scaling e-commerce workflow. Browse 14 product categories and discover powerful automation tools.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/search?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'ACBuySpreadsheet',
  url: `${siteUrl}/`,
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/acdcfd47829ab306d380ea84eb14e50b.jpeg',
  description: 'ACBuySpreadsheet provides structured spreadsheet systems for tracking orders, calculating profit, and automating e-commerce reseller workflows.',
  sameAs: ['https://kaspreadsheet.com/'],
};

export default function Home() {
  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <Navbar />
      <Hero />
      <BrandIntro />
      <CategoryGrid />
      <FeatureCards />
      <ArticleResources />
      <Testimonial />
      <CTASection />
      <Footer />
    </main>
  );
}